export const ENDPOINTS = {
  savedSearches: 'saved-searches',
  savedSearch: 'saved-searches/:id'
};
